import * as React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Pie } from 'react-chartjs-2';
import { HorizontalBar } from 'react-chartjs-2';
import { BasePureComponent } from './BaseComponent';

interface IGraficoState {

}

interface IGrafico {
    Titolo: string;
    Larghezza: number;
    Altezza: number;
    Etichette: string[];
    Dati: number[];
    ColoriDiSfondo: string[];
    ColoriDiSfondoSuSelezione: string[];
}

interface IGraficoTortaProps extends IGrafico {

}

export class GraficoTorta extends React.Component<IGraficoTortaProps, IGraficoState> {
    static getDerivedStateFromProps(props: IGraficoTortaProps, state: IGraficoState): IGraficoState {
        return ({
            width: props.Larghezza,
            height: props.Altezza,

            labels: props.Etichette,
            datasets: [{
                data: props.Dati,
                backgroundColor: props.ColoriDiSfondo,
                hoverBackgroundColor: props.ColoriDiSfondoSuSelezione
            }]
        });
    }
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render() {
        return (<div>
            <h3>{this.props.Titolo}</h3>
            <Pie data={this.state} />
        </div>
        );
    }
}

export class GraficoCiambella extends React.Component<IGraficoTortaProps, IGraficoState> {
    static getDerivedStateFromProps(props: IGraficoTortaProps, state: IGraficoState): IGraficoState {
        return ({
            width: props.Larghezza,
            height: props.Altezza,

            labels: props.Etichette,
            datasets: [{
                data: props.Dati,
                backgroundColor: props.ColoriDiSfondo,
                hoverBackgroundColor: props.ColoriDiSfondoSuSelezione
            }]
        });
    }

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render() {
        return (<div>
            <h3>{this.props.Titolo}</h3>
            <Doughnut data={this.state} />
        </div>
        );
    }
}

interface IGraficoLimiteProps {
    Titolo: string;
    Larghezza: number;
    Altezza: number;
    EtichettaConsumato: string;
    EtichettaRimanente: string;
    ValoreConsumato: number;
    ValoreRimanente: number;
}
export class GraficoLimite extends BasePureComponent<IGraficoLimiteProps, IGraficoState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private Inizialize(props: IGraficoLimiteProps, state: IGraficoState): IGraficoState {
        let _ColoreSfondoConsumato: string = "";
        let _ColoreSfondoRimanente: string = "";

        _ColoreSfondoConsumato = "#34bfa3";
        if (props.ValoreConsumato < props.ValoreRimanente) {
            _ColoreSfondoRimanente = "#4189c7";
        } else if (props.ValoreConsumato >= props.ValoreRimanente && props.ValoreConsumato < props.ValoreRimanente + (props.ValoreRimanente * 20 / 100)) {
            _ColoreSfondoRimanente = "#F1870A";
        } else {
            _ColoreSfondoRimanente = "#4189c7";
        }

        return ({
            width: props.Larghezza,
            height: props.Altezza,

            labels: [props.EtichettaConsumato, props.EtichettaRimanente],
            datasets: [{
                data: [props.ValoreConsumato, props.ValoreRimanente],
                backgroundColor: [_ColoreSfondoConsumato, _ColoreSfondoRimanente],
                hoverBackgroundColor: [_ColoreSfondoConsumato, _ColoreSfondoRimanente]
            }]
        });
    }

    public render() {
        return (<div>
            <h3>{this.props.Titolo}</h3>
            <Doughnut data={this.Inizialize(this.props, this.state)} />
        </div>
        );
    }
}

interface IGraficoBarreProps extends IGrafico {
    ColoreBordo: string;
    ColoreBordoSuSelezione: string;
    SpessoreBordo: number;
}

export class GraficoBarreOrizzontale extends React.Component<IGraficoBarreProps, IGraficoState> {
    static getDerivedStateFromProps(props: IGraficoBarreProps, state: IGraficoState): IGraficoState {
        return ({
            width: props.Larghezza,
            height: props.Altezza,

            labels: props.Etichette,
            datasets: [{
                data: props.Dati,
                backgroundColor: props.ColoriDiSfondo,
                hoverBackgroundColor: props.ColoriDiSfondoSuSelezione,
                borderColor: props.ColoreBordo,
                hoverBorderColor: props.ColoreBordoSuSelezione,
                borderWidth: props.SpessoreBordo,
                label: props.Etichette
            }]
        });
    }

    private CreaOpzioni(): any {
        return ({
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }],
                xAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        });
    }
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render() {
        return (<div>
            <h3>{this.props.Titolo}</h3>
            <HorizontalBar data={this.state} options={this.CreaOpzioni()} />
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Grafici.tsx